import React, { useState } from 'react';
import { requestPasswordReset } from '../../services/auth';
import FormField from '../FormField';
import Input from '../Input';
import LottieAnimation from './LottieAnimation';
import ProxyImage from '../ProxyImage';
import './Auth.css';

interface ForgotPasswordProps {
  onBack: () => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrors({});
    setMessage(null);

    if (!email.trim()) {
      setErrors({ email: 'Email requerido' });
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setErrors({ email: 'Email inválido' });
      return;
    }

    setLoading(true);

    try {
      const result = await requestPasswordReset(email);

      if (result.success) {
        setMessage('Si el email existe, recibirás instrucciones para recuperar tu contraseña.');
      } else {
        setErrors({ general: result.error || 'Error al solicitar recuperación' });
      }
    } catch (error) {
      setErrors({ general: 'Error de conexión. Por favor, intenta nuevamente.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-wrapper">
        <div className="auth-lottie-column">
          <div className="auth-logo">
            <a 
              href="https://smartcityexposantiagodelestero.com/" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <ProxyImage 
                src="https://smartcityexposantiagodelestero.com/wp-content/uploads/2025/03/Logo-SCESDE26-Negro-e1751508867641-1536x213.png" 
                alt="Smart City Expo Santiago del Estero" 
              />
            </a>
          </div>
          <LottieAnimation />
          <div className="auth-partners-image">
            <ProxyImage 
              src="https://smartcityexposantiagodelestero.com/wp-content/uploads/2026/01/Instituciones-Colaboradoras-Web-scaled-e1767776957958.png" 
              alt="Instituciones Colaboradoras" 
            />
          </div>
        </div>
        <div className="auth-form-column">
          <div className="auth-card">
            <div className="auth-logo-mobile">
              <a 
                href="https://smartcityexposantiagodelestero.com/" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <ProxyImage 
                  src="https://smartcityexposantiagodelestero.com/wp-content/uploads/2025/03/Logo-SCESDE26-Negro-e1751508867641-1536x213.png" 
                  alt="Smart City Expo Santiago del Estero" 
                />
              </a>
            </div>
        <h2 className="auth-title">Recuperar Contraseña</h2>
        <p className="auth-subtitle">Ingresa tu email y te enviaremos instrucciones para recuperar tu contraseña</p>

        {message && (
          <div className="auth-message success">
            {message}
          </div>
        )}

        {errors.general && (
          <div className="auth-message error">
            {errors.general}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <FormField label="Correo electrónico" required error={errors.email}>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="correo@ejemplo.com"
              error={!!errors.email}
              disabled={loading}
            />
          </FormField>

          <button 
            type="submit" 
            className="auth-button"
            disabled={loading}
          >
            {loading ? 'Enviando...' : 'Enviar Instrucciones'}
          </button>
        </form>

        <div className="auth-switch">
          <button type="button" onClick={onBack} className="auth-link">
            ← Volver al inicio de sesión
          </button>
        </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
